//For Deployment to Main Site, change the URLs to the following :
//export const BASE_URL = "https://www.manashakti.org/admin/backend/index.php/";
//export const IMAGE_URL = "https://www.manashakti.org/admin/backend/uploads/";

//For Deployment to Prepod, change the URLs to the following :
// export const BASE_URL = "http://192.168.29.112/admin/backend/index.php/";
// export const BASE_URL = "https://www.manashakti.org/admin/backend/index.php/";
// export const IMAGE_URL = "https://www.manashakti.org/admin/backend/uploads/";
export const BASE_URL = "https://www.manashakti.org/admin/backend/index.php/";
export const IMAGE_URL = "https://www.manashakti.org/uploads/user/";

// Node.js API Base URL (for all auth, orders, profile, download_gallery, etc.)
export const NODE_API_BASE = process.env.REACT_APP_NODE_API_BASE || "https://www.manashakti.org/api";

// Derived endpoints - all use NODE_API_BASE for consistency
export const AUTH_API = `${NODE_API_BASE}/auth`;
export const PASSWORD_API = `${NODE_API_BASE}/auth`;              // Same as AUTH_API - for password operations
export const PROFILE_API = `${NODE_API_BASE}/profile`;
export const ORDER_EMAIL_API = `${NODE_API_BASE}/orders`;
export const GUEST_AUTH_API = `${NODE_API_BASE}/auth/guest`;
export const NodeAPI = `${NODE_API_BASE}/download_gallery`;       // Download gallery endpoint
export const CONFIRM_EMAIL_API = `${NODE_API_BASE}/orders/confirm-email`;
//export const PROFILE_PIC_API = `${NODE_API_BASE}/uploads/user/`;  // Profile picture endpoint
// Profile Picture Utility Functions

export const sendConfirmEmail = async (orderData) => {
  try {
    const response = await fetch(CONFIRM_EMAIL_API, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(orderData),
    });
    return response;
  } catch (error) {
    console.error('Error sending confirmation email:', error);
    throw error;
  }
};

export const getProfilePictureUrl = async (userId) => {
  try {
    const response = await fetch(`${PROFILE_API}/picture/${userId}`);
    const data = await response.json();
    
    if (data.status === "true" && data.profile_picture_url) {
      return data.profile_picture_url;
    }
    return null;
  } catch (error) {
    console.error('Error fetching profile picture:', error);
    return null;
  }
};

export const getProfilePictureUrlSync = (userId) => {
  // For cases where we need synchronous access (like in JSX)
  const cachedUrl = localStorage.getItem(`profile_picture_url_${userId}`);
  if (cachedUrl && cachedUrl !== 'null') {
    return cachedUrl;
  }
  
  // Fallback to default user image
  return '/profile.png';
};

// Function to cache profile picture URL
export const cacheProfilePictureUrl = async (userId) => {
  const url = await getProfilePictureUrl(userId);
  if (url) {
    localStorage.setItem(`profile_picture_url_${userId}`, url);
    return url;
  }
  return null;
};

// Utility function to get only product count (excludes events and magazines)
export async function getProductCartCount(user_id) {
  try {
    const produtsUrl = `${BASE_URL}cart/getAllMyCartData/${user_id}/en`;
    const productsData = await (await fetch(produtsUrl)).json();
    return productsData.length; // Only count products
  } catch (error) {
    console.log('Error getting product cart count:', error);
    return 0;
  }
}

// Utility function to check if cart has products
export async function cartHasProducts(user_id) {
  try {
    const produtsUrl = `${BASE_URL}cart/getAllMyCartData/${user_id}/en`;
    const productsData = await (await fetch(produtsUrl)).json();
    return productsData.length > 0;
  } catch (error) {
    console.log('Error checking if cart has products:', error);
    return false;
  }
}

// Utility function to check if cart has magazines
export async function cartHasMagazines(user_id) {
  try {
    const magazinesUrl = `${BASE_URL}cart/getAllMyCartDataForMagazine/${user_id}/en`;
    const magazinesData = await (await fetch(magazinesUrl)).json();
    return magazinesData.length > 0;
  } catch (error) {
    console.log('Error checking if cart has magazines:', error);
    return false;
  }
}

// Utility function to check if cart has events (including both regular events and machine tests)
export async function cartHasEvents(user_id) {
  try {
    const eventItemsUrl = `${BASE_URL}cart/getAllMyCartDataForEvents/${user_id}/en`;
    const machineTestItemsUrl = `${BASE_URL}cart/getAllMyCartDataForMachineTestEvents/${user_id}/en`;
    
    const [eventItemsData, machineTestItemsData] = await Promise.all([
      (await fetch(eventItemsUrl)).json(),
      (await fetch(machineTestItemsUrl)).json(),
    ]);
    
    return eventItemsData.length + machineTestItemsData.length > 0;
  } catch (error) {
    console.log('Error checking if cart has events:', error);
    return false;
  }
}

// Utility function to check if cart has regular events (excluding machine tests)
export async function cartHasRegularEvents(user_id) {
  try {
    const eventItemsUrl = `${BASE_URL}cart/getAllMyCartDataForEvents/${user_id}/en`;
    const eventItemsData = await (await fetch(eventItemsUrl)).json();
    
    return eventItemsData.length > 0;
  } catch (error) {
    console.log('Error checking if cart has regular events:', error);
    return false;
  }
}

// Utility function to check if cart has machine tests
export async function cartHasMachineTests(user_id) {
  try {
    const machineTestItemsUrl = `${BASE_URL}cart/getAllMyCartDataForMachineTestEvents/${user_id}/en`;
    const machineTestItemsData = await (await fetch(machineTestItemsUrl)).json();
    
    return machineTestItemsData.length > 0;
  } catch (error) {
    console.log('Error checking if cart has machine tests:', error);
    return false;
  }
}



// Utility function to get cart conflict message
export function getCartConflictMessage(hasProducts, hasMagazines, hasEvents, getLanguage) {
  const language = getLanguage ? getLanguage() : 'en';
  
  if (hasProducts) {
    if (hasEvents) {
      return language === 'en' 
        ? 'Cart contains products and events. Please checkout or clear cart to add magazines.'
        : 'कार्टमध्ये उत्पादने आणि कार्यक्रम आहेत. मासिके जोडण्यासाठी कृपया चेकआउट करा किंवा कार्ट साफ करा.';
    } else {
      return language === 'en' 
        ? 'Cart contains products. Please checkout or clear cart to add magazines.'
        : 'कार्टमध्ये उत्पादने आहेत. मासिके जोडण्यासाठी कृपया चेकआउट करा किंवा कार्ट साफ करा.';
    }
  } else if (hasMagazines) {
    if (hasEvents) {
      return language === 'en'
        ? 'Cart contains magazines and events. Please checkout or clear cart to add products.'
        : 'कार्टमध्ये मासिके आणि कार्यक्रम आहेत. उत्पादने जोडण्यासाठी कृपया चेकआउट करा किंवा कार्ट साफ करा.';
    } else {
      return language === 'en'
        ? 'Cart contains magazines. Please checkout or clear cart to add products.'
        : 'कार्टमध्ये मासिके आहेत. उत्पादने जोडण्यासाठी कृपया चेकआउट करा किंवा कार्ट साफ करा.';
    }
  } else if (hasEvents) {
    return language === 'en'
      ? 'Cart contains events. Please checkout or clear cart to add products or magazines.'
      : 'कार्टमध्ये कार्यक्रम आहेत. उत्पादने किंवा मासिके जोडण्यासाठी कृपया चेकआउट करा किंवा कार्ट साफ करा.';
  }
  return '';
}

// Utility function to get cart count for display (products OR magazines OR events, whichever is in cart)
export async function getCartDisplayCount(user_id) {
  try {
    // Check if cart has products
    const hasProducts = await cartHasProducts(user_id);
    if (hasProducts) {
      return await getProductCartCount(user_id);
    }
    
    // Check if cart has magazines
    const hasMagazines = await cartHasMagazines(user_id);
    if (hasMagazines) {
      const magazinesUrl = `${BASE_URL}cart/getAllMyCartDataForMagazine/${user_id}/en`;
      const magazinesData = await (await fetch(magazinesUrl)).json();
      return magazinesData.length;
    }
    
    // Check if cart has events
    const hasEvents = await cartHasEvents(user_id);
    if (hasEvents) {
      const eventItemsUrl = `${BASE_URL}cart/getAllMyCartDataForEvents/${user_id}/en`;
      const machineTestItemsUrl = `${BASE_URL}cart/getAllMyCartDataForMachineTestEvents/${user_id}/en`;
      
      const [eventItemsData, machineTestItemsData] = await Promise.all([
        (await fetch(eventItemsUrl)).json(),
        (await fetch(machineTestItemsUrl)).json(),
      ]);
      
      return eventItemsData.length + machineTestItemsData.length;
    }
    
    // Cart is empty
    return 0;
  } catch (error) {
    console.log('Error getting cart display count:', error);
    return 0;
  }
}

// Utility function to send guest order confirmation email
export async function sendGuestOrderConfirmationEmail(orderData) {
  try {
    const { email, orderIdMain, firstName, userId } = orderData;
    
    // Validate required fields
    if (!email || !orderIdMain || !userId) {
      console.error('MISSING FIELDS - Cannot send email:', {
        email: !!email,
        email_value: email,
        orderIdMain: !!orderIdMain,
        orderIdMain_value: orderIdMain,
        userId: !!userId,
        userId_value: userId
      });
      return { success: false, message: 'Missing required fields' };
    }

    const requestBody = {
      email: email,
      orderIdMain: orderIdMain,
      firstName: firstName || '',
      user_type: "guest",
      userId: parseInt(userId)
    };

    const apiUrl = `${ORDER_EMAIL_API}/confirm-email`;
    console.log('=== SENDING GUEST ORDER EMAIL ===');
    console.log('API URL:', apiUrl);
    console.log('Request Body:', requestBody);

    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(requestBody)
    });

    console.log('API Response Status:', response.status);
    console.log('API Response OK:', response.ok);
    console.log('API Response Headers:', {
      contentType: response.headers.get('content-type'),
      status: response.status,
      statusText: response.statusText
    });

    if (!response.ok) {
      console.error('API ERROR - HTTP Status:', response.status);
      const errorText = await response.text();
      console.error('Error Response:', errorText);
      return { 
        success: false, 
        message: `API Error: ${response.status} - ${response.statusText}`,
        httpStatus: response.status,
        errorText: errorText
      };
    }

    const result = await response.json();
    console.log('API Response Data:', result);
    
    if (result.status === 'true' && result.emailSent) {
      console.log('Order confirmation email sent successfully to:', email);
      return { success: true, message: 'Email sent successfully', data: result };
    } else {
      console.warn('Email API responded but no email sent:', result.message);
      return { success: false, message: result.message, data: result };
    }
  } catch (error) {
    console.error('EXCEPTION in sendGuestOrderConfirmationEmail:', error);
    console.error('Error details:', {
      name: error.name,
      message: error.message,
      stack: error.stack
    });
    // Don't block the order flow - email is optional
    return { success: false, message: error.message, error: error };
  }
}

//For Localhost, change the URLs to the following :
//export const BASE_URL = "localhost/admin/backend/index.php/";
//export const IMAGE_URL = "localhost/admin/backend/uploads/";

// Extra Stuff only for reference :

//export const BASE_URL = "http://127.0.0.1:8000/admin/backend/index.php/";
//export const IMAGE_URL = "https://127.0.0.1:8000/admin/backend/uploads/";

//export const BASE_URL_1 = window.location.href;
//export const BASE_URL_SPLIT= BASE_URL_1.split('/');
//export const BASE_URL= BASE_URL_SPLIT[0]+"//"+BASE_URL_SPLIT[2]+ "/admin/backend/index.php/";
//export const IMAGE_URL= BASE_URL_SPLIT[0]+"//"+BASE_URL_SPLIT[2]+ "/admin/backend/uploads/";

//export const BASE_URL = "http://localhost/admin/backend/index.php/";
//export const IMAGE_URL = "http://localhost/admin/backend/uploads/";
